import { render, staticRenderFns } from "./AdminReportBuyersActivity.vue?vue&type=template&id=4a5a5e59&scoped=true"
import script from "./AdminReportBuyersActivity.vue?vue&type=script&lang=js"
export * from "./AdminReportBuyersActivity.vue?vue&type=script&lang=js"
import style0 from "./AdminReportBuyersActivity.vue?vue&type=style&index=0&id=4a5a5e59&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5a5e59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a5a5e59')) {
      api.createRecord('4a5a5e59', component.options)
    } else {
      api.reload('4a5a5e59', component.options)
    }
    module.hot.accept("./AdminReportBuyersActivity.vue?vue&type=template&id=4a5a5e59&scoped=true", function () {
      api.rerender('4a5a5e59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminReportBuyersActivity.vue"
export default component.exports